import { Component, Vue, Watch as watch} from 'nuxt-property-decorator';
import {mapGetters, mapState} from 'vuex';
import yandexMap, {ymapMarker, loadYmap} from 'vue-yandex-maps'

declare var ymaps: any;

@Component({
    components: {
        store: require('~/components/pages/about/stores/store-template').default,
        citySelect: require('~/components/pages/about/stores/city-select').default,
        yandexMap
    },
    computed: mapState(['region']),
})
export default class RetailStoresPageComponent extends Vue {

    public stores: any[] = [];
    public cities: any[] = [];
    public region!: Store.CurrentRegion;
    public cityCode: string = '';
    public map;

    public addressCache: Map<string, [number, number]> = new Map();

    private mapLoaded = false;
    private shouldInitBaloons = false;
    private shouldLoadMap = false;

    mounted() {
        this.loadCoordCache();
        this.initMap();
    }

    public head() {
        return {
            title: 'Адреса магазинов - Интернет-магазин мебели «ТриЯ»',
            meta: [
                { vmid: 'description', name: 'description', content: 'Адреса магазинов и контактные телефоны фирменной мебели «ТриЯ».' }
            ]
        };
    }

    @watch('cityCode')
    onCityChange() {
        this.$fetch();
    }

    async fetch() {

        if (!this.cities.length) {
            this.cities =  await this.$store.dispatch('RestRequest', {
                url: '/info/retail-city-list',
            });
            this.cities.forEach((el) => {
                el.full_name = `${el.name}${el.region ? `, ${el.region}` : ''}`;
            });
        }

        if (!this.cityCode) {
            const targetCity = this.cities.find((el) => el.name === this.region.name);
            if (targetCity) {
                this.cityCode = targetCity.code;
            }
        }

        if (this.shouldLoadMap) {
            this.initMap();
        }

        this.stores = await this.$store.dispatch('data/FetchRetailStores', {
            city: this.cityCode
        });

        this.stores.sort((a, b) => {
            if (a.type !== b.type) {
                return a.type === 'own' ? -9999 : 9999;
            }

            return (a.name as string).localeCompare(b.name);
        })

        if (this.mapLoaded) {
            this.moveMapToCity();
            this.initBallons();
        } else {
            this.shouldInitBaloons = true;
        }
    }

    scrollToMap() {
        (this.$refs['map'] as HTMLElement).scrollIntoView({
            behavior: 'smooth'
        });
    }

    async moveMapToCity() {
        const geocoder = await ymaps.geocode(this.currentCity.full_name);
        const city = geocoder.geoObjects.get(0);

        this.map.setCenter(city.geometry._coordinates, 10);
    }

    async initMap() {

        if (!this.currentCity) {
            this.shouldLoadMap = true;
            return;
        }

        this.shouldLoadMap = false;

        await loadYmap({
            apiKey: 'e233be39-9e42-4f00-8153-506579e3c0b7',
        });

        const geocoder = await ymaps.geocode(this.currentCity.full_name);
        const city = geocoder.geoObjects.get(0);

        this.map = new ymaps.Map(this.$refs['map'], {
            center: city.geometry._coordinates,
            zoom: 10
        }, {
            searchControlProvider: 'yandex#search'
        });

        this.mapLoaded = true;

        if (this.shouldInitBaloons) {
            this.initBallons();
        }
    }

    beforeDestroy() {
        this.map?.destroy();
    }

    initBallons() {

        this.map.geoObjects.removeAll();

        const template = ymaps.templateLayoutFactory.createClass(
            '<div class="map-template">'+
                '<h4>{{properties.name}}</h4>'+
                '{% if properties.address %} <div class="map-field"><i class="fa fa-map-marker" aria-hidden="true" title="Адрес"></i> {{properties.address}}</div> {% endif %}'+
                '{% if properties.time %} <div class="map-field"><i class="fa fa-clock-o" aria-hidden="true" title="Время работы"></i>{{properties.time}}</div> {% endif %}'+
                '{% if properties.phone %} <div class="map-field"><i class="fa fa-phone" aria-hidden="true" title="Телефон"></i>{{properties.phone}}</div> {% endif %}'+
                '{% if properties.email %} <div class="map-field"><i class="fa fa-envelope" aria-hidden="true" title="Email"></i>{{properties.email}}</div> {% endif %}'+
                '{% if properties.metro %} <div class="map-field"><i class="fa fa-train" aria-hidden="true" title="Метро"></i>{{properties.metro}}</div> {% endif %}'+
            '</div>');

        for (const store of this.stores) {
            if (store.address) {

                if (this.addressCache.has(store.address)) {
                    const coords = this.addressCache.get(store.address);
                    if (coords) {
                        this.createMapMark(template, store, coords);
                    }
                } else {
                    ymaps.geocode(store.address).then((data) => {
                        const location = data.geoObjects.get(0);
                        if (location) {
                            this.addressCache.set(store.address, location.geometry._coordinates);
                            this.saveCoordCache();
                            this.createMapMark(template, store, location.geometry._coordinates);
                        }
                    });
                }
            }
        }

        this.shouldInitBaloons = false;
    }

    private createMapMark(template, store, coords) {
        store.phone = store.phones.join(', ');
    
        const mark = new ymaps.Placemark(
            coords,
            store,
            {
                balloonContentLayout: template,
                preset: 'islands#dotIcon',
                iconColor: store.type === 'own' ? '#ed1e24' : '#F26838'
            });
        
        Vue.set(store, 'mark', mark);
        this.map.geoObjects.add(mark); 
    }

    private saveCoordCache() {
        sessionStorage.setItem('coord-cache', JSON.stringify([...this.addressCache.entries()]));
    }

    private loadCoordCache() {
        try {
            const cache = sessionStorage.getItem('coord-cache');

            if (cache) {
                this.addressCache = new Map(JSON.parse(cache));
            }
        } catch {
            this.addressCache = new Map();
        }
    }

    get currentCity() {
        if (!this.cities?.length) {
            return null;
        }

        return this.cities.find((el) => el.code === this.cityCode);
    }
}
